import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { PlanfixImportPage } from './planfix-import-journal.model';

const IMPORTS_URL = '/backend/admin/planfix/imports';
const PAGE_QUERY = '?page=';
const LOG_PATH = '/log';
const PATH_SEPARATOR = '/';

@Injectable()
export class PlanfixImportJournalService {
  constructor(private http: Http) {}

  fetchPage(page: number): Observable<PlanfixImportPage> {
    return this.http.get(IMPORTS_URL + PAGE_QUERY + page)
      .map(response => response.json() as PlanfixImportPage);
  }

  fetchLog(runId: string): Observable<string> {
    return this.http.get(IMPORTS_URL + PATH_SEPARATOR + encodeURIComponent(runId) + LOG_PATH)
      .map(response => response.text());
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/planfix-import-journal/planfix-import-journal.service.ts